import React from 'react';
import DriveTimesView from './screens/DriveTimesView';
import StopView from './screens/StopView';
import MapView from './screens/MapView';
import TrainView from './screens/TrainView';
import { config } from './config';

export interface Screen {
  id: string;
  name: string;
  component: React.ComponentType;
}

// Build screens array based on config
const allScreens: Array<Screen & { enabled: boolean }> = [
  {
    id: 'drive',
    name: 'Drive Times & Traffic',
    component: DriveTimesView,
    enabled: config.screens.driveTimesView
  },
  {
    id: 'stop',
    name: 'Stop Arrivals',
    component: StopView,
    enabled: config.screens.stopView
  },
  {
    id: 'train',
    name: 'Train Times',
    component: TrainView,
    enabled: config.screens.trainView
  },
  {
    id: 'map',
    name: 'Route Map',
    component: MapView,
    enabled: config.screens.mapView
  }
];

// Filter to only enabled screens
export const screens: Screen[] = allScreens
  .filter(screen => screen.enabled)
  .map(({ enabled, ...screen }) => screen);
